var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filtered-search',{key:_vm.filteredSearchKey,staticClass:"gl-w-full",attrs:{"namespace":"","terms-as-tokens":"","tokens":_vm.tokens,"search-input-placeholder":_vm.$options.i18n.search,"initial-filter-value":_vm.getFilteredSearchValue},on:{"onFilter":_vm.handleFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }